// https://a.yandex-team.ru/arcadia/mssngr/router/lib/protos/message.proto?rev=r9866024#L164
export const SERVICE_ID_EXTERNAL = 65;
export const SERVICE_ID_INTERNAL = 66;
